import { render, staticRenderFns } from "./caseMateria.vue?vue&type=template&id=5ed4eba4&scoped=true"
import script from "./caseMateria.vue?vue&type=script&lang=js"
export * from "./caseMateria.vue?vue&type=script&lang=js"
import style0 from "./caseMateria.vue?vue&type=style&index=0&id=5ed4eba4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed4eba4",
  null
  
)

export default component.exports